export default () => {
  const camelToSnake = (str: string): string => {
    return str.replace(/[A-Z]/g, (c) => {
      return '_' + c.toLowerCase();
    });
  };

  const snakeToCamel = (str: string): string => {
    return str?.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  };

  return { camelToSnake, snakeToCamel };
};
